<script lang="ts">
	import type { ComponentType } from '@wiseed/wikit';
	import ProjectHeaderInfo from '../elements/ProjectHeaderInfo.svelte';
	import { t } from 'svelte-i18n';
	import { capitalize, formatAmountWithCurrency } from '@wiseed/wikit';
	import {
		createFinancialInstrumentHeaderComponent,
		getTaxExemptionString,
		hasAmountReachedExcludingWiseed,
		isGoalAmountReachedFn,
		isMinAmountReachedFn
	} from '@app/utils/operations';
	import type { OperationModel } from '@app/models/api/OperationModel';
	import ProjectHeader from '../ProjectHeader.svelte';
	import { page } from '$app/stores';
	import { SVG } from '@wiseed/wikit';
	import { urls } from '@app/urls';
	import { OperationStatusEnum } from '@app/models/api/enums/OperationStatusEnum';
	import { TargetTypeEnum } from '@app/models/api/enums/TargetTypeEnum';

	export let operation: OperationModel;
	let isMinAmountReached = isMinAmountReachedFn(operation);
	let isGoalAmountReached = isGoalAmountReachedFn(operation);
	let headerComponents: ComponentType[] = [];

	!operation.status?.includes(OperationStatusEnum.VOTE) &&
		(headerComponents = [
			{
				component: ProjectHeaderInfo,
				props: {
					label: isGoalAmountReached
						? ''
						: isMinAmountReached
							? $t('operation.headers.minAmountReached')
							: $t('operation.headers.objectives'),
					value: isGoalAmountReached
						? $t('operation.headers.goalAmountReached')
						: formatAmountWithCurrency(
								hasAmountReachedExcludingWiseed(operation)
									? operation.amountNeededMin + operation.amountReachedExcludingWiseed
									: operation.amountNeededMin
							),
					hint:
						hasAmountReachedExcludingWiseed(operation) && !isGoalAmountReached
							? $t('operation.amountHint', {
									values: {
										amountWiSEED: formatAmountWithCurrency(operation.amountNeededMin),
										amountOutsideWiSEED: formatAmountWithCurrency(
											operation.amountReachedExcludingWiseed
										)
									}
								})
							: undefined,
					classNames: isMinAmountReached || isGoalAmountReached ? 'text-success' : ''
				}
			},
			createFinancialInstrumentHeaderComponent(operation),
			{
				component: ProjectHeaderInfo,
				props: {
					label: $t('operation.headers.sharesOutingsHorizonLabel'),
					value: $t('operation.headers.sharesOutingsHorizon')
				}
			},
			{
				component: ProjectHeaderInfo,
				props: {
					label: $t('operation.headers.taxExemption.label'),
					hint: $t('operation.headers.taxExemption.hint'),
					url: urls.INVESTORS.TAXATION,
					value:
						!!operation.isIRPPTaxExempted || !!operation.isDisposalContributionTaxExempted
							? capitalize(getTaxExemptionString(operation))
							: {
									component: SVG,
									props: {
										name: 'lock',
										classNames: 'text-primary',
										tooltip: {
											content: $page.data?.user
												? capitalize($t('needWallet'))
												: capitalize($t('needLoginShort'))
										}
									}
								}
				}
			}
		]);

	!operation.status?.includes(OperationStatusEnum.VOTE) &&
		operation.targetType !== TargetTypeEnum.CLUB_DEAL &&
		headerComponents.splice(headerComponents.length - 1, 0, {
			component: ProjectHeaderInfo,
			props: {
				label: $t('operation.headers.valuation'),
				value:
					operation.valorisation !== undefined
						? formatAmountWithCurrency(operation.valorisation)
						: operation.valuationMax &&
							  operation.valuationMin &&
							  operation.valuationMax !== operation.valuationMin
							? `Entre ${formatAmountWithCurrency(
									operation.valuationMin
								)} et ${formatAmountWithCurrency(operation.valuationMax)}`
							: operation.valuationMin
								? formatAmountWithCurrency(operation.valuationMin)
								: operation.valuationMax
									? formatAmountWithCurrency(operation.valuationMax)
									: {
											component: SVG,
											props: {
												name: 'lock',
												classNames: 'text-primary',
												tooltip: {
													content: $page.data?.user
														? capitalize($t('needWallet'))
														: capitalize($t('needLoginShort'))
												}
											}
										}
			}
		});
</script>

<ProjectHeader components={headerComponents} />
